"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SettingsButton = _interopRequireDefault(require("../NavSettings/SettingsButton"));

var _SettingsDropdown = _interopRequireDefault(require("../NavSettings/SettingsDropdown"));

var _color = _interopRequireDefault(require("color"));

var _Colorpicker = _interopRequireDefault(require("./Colorpicker"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  icon: {
    position: "absolute",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    fontSize: 'inherit',
    width: '1.15em',
    height: '1.15em',
    borderRadius: '1em',
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: props => {
      return props.color;
    },
    margin: "-0.075em"
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: '0.75em',
    fontWeight: "bold",
    lineHeight: '1',
    textAlign: "center"
  }
}));

const ColorIcon = ({
  variant,
  backgroundColor,
  color,
  contrastColor
}) => {
  if (variant === "text") {
    backgroundColor = backgroundColor || contrastColor;
  } else {
    backgroundColor = color;
    color = contrastColor;
  }

  const classes = useStyles({
    backgroundColor,
    color
  });
  const label = variant === "text" && "T" || "";
  return _react.default.createElement(_Paper.default, {
    className: classes.icon,
    elevation: 1
  }, _react.default.createElement("b", {
    className: classes.label
  }, label));
};

const getOptions = ({
  options = []
}) => {
  let _colors = [],
      _options = [],
      _byValue = {};
  options.length && options.map((item, index) => {
    if (typeof item === "string") {
      item = {
        label: item,
        value: item
      };
    }

    _colors.push(item.value);

    _options.push(item);
  });
  return {
    colors: _colors,
    options: _options
  };
};

const SettingsButtonRef = (0, _react.forwardRef)((props, ref) => {
  const icon = ColorIcon(props);
  return _react.default.createElement(_SettingsButton.default, _extends({}, props, {
    icon: icon,
    forwardedRef: ref
  }));
});

const ColorSettings = (_ref) => {
  let _ref$type = _ref.type,
      type = _ref$type === void 0 ? "color" : _ref$type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      backgroundColor = _ref.backgroundColor,
      buttonLabel = _ref.buttonLabel,
      name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "variant", "backgroundColor", "buttonLabel", "name", "label", "value", "onChange"]);

  const _useState = (0, _react.useState)(false),
        expanded = _useState[0],
        setExpanded = _useState[1];

  const anchorRef = (0, _react.useRef)(null);

  const _getOptions = getOptions(props),
        colors = _getOptions.colors;

  if (!value && colors.length) {
    value = colors[0];
  }

  const primaryColor = (0, _color.default)(value);
  const color = primaryColor.hex();
  const contrastColor = primaryColor.isLight() && "black" || "white";

  if (variant === "text") {
    backgroundColor = backgroundColor || contrastColor;
  } else {
    backgroundColor = color;
  }

  const arrowColor = backgroundColor;

  const handleToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const handleCollapse = () => {
    setExpanded(false);
  };

  const handleChange = ({
    hex
  }) => {
    console.log("COLOR CHANDED", color);
    onChange && onChange(name, hex);
  };

  const handleSelect = color => {
    onChange && onChange(name, color);
    setExpanded(false);
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(SettingsButtonRef, {
    type: type,
    value: value,
    variant: variant,
    backgroundColor: backgroundColor,
    color: color,
    contrastColor: contrastColor,
    onToggle: handleToggle,
    expanded: expanded,
    ref: anchorRef
  }), _react.default.createElement(_SettingsDropdown.default, {
    expanded: expanded,
    anchorEl: anchorRef.current,
    arrowColor: arrowColor,
    onCollapse: handleCollapse
  }, _react.default.createElement(_Colorpicker.default, {
    variant: variant,
    backgroundColor: backgroundColor,
    color: color,
    colors: colors,
    onChange: handleChange
  })));
};

ColorSettings.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes.default.string,
  options: _propTypes.default.array
} : {};
var _default = ColorSettings;
exports.default = _default;
module.exports = exports.default;